export const BULK_CHANGES_BAR_BODY_CLASS = 'reactBulkChangesBar';
